'use client';

import { DropdownMenuSub } from '@heidi/design-system/dropdown-menu';
import * as React from 'react';

import { SubContext, VariantContext } from './context';

type AdaptiveMenuSubProps = {
  children: React.ReactNode;
  /** Label shown in the mobile drill-down back header. */
  title: React.ReactNode;
  onOpenChange?: (open: boolean) => void;
};

export const AdaptiveMenuSub = ({
  children,
  title,
  onOpenChange,
}: AdaptiveMenuSubProps) => {
  const variant = React.useContext(VariantContext);
  const subId = React.useId();

  if (variant === 'menu') {
    return <DropdownMenuSub onOpenChange={onOpenChange}>{children}</DropdownMenuSub>;
  }
  return (
    <SubContext.Provider value={{ subId, title, onOpenChange }}>
      {children}
    </SubContext.Provider>
  );
};
